import moment from "moment";
import 'moment-timezone';

// All API dates are returned in Europe/Madrid (Laravel app.timezone)
const SERVER_TIMEZONE = 'Europe/Madrid';

export class DateHelper {
  static shortDateFormat(time: string): string {
    return moment(time).format('DD/MM/YY');
  }
  static dateFormat(time: string): string {
    return moment(time).format('D MMM Y');
  }
  static longDateFormat(time:string): string {
    return moment(time).format('dddd, D MMM Y');
  }
  static dateTimeFormat(time: string): string {
    return moment(time).format('YYYY-MM-DD HH:mm');
  }
  static longDateTimeFormat(time:string): string {
    return moment(time).format('HH:mm dddd, D MMM Y');
  }
  static dateFormatTz(time: string, targetTz: string): string {
    return moment.tz(time, SERVER_TIMEZONE).tz(targetTz).format('D MMM Y');
  }
  static timeFormatTz(time: string, targetTz: string): string {
    return moment.tz(time, SERVER_TIMEZONE).tz(targetTz).format('HH:mm');
  }
  static longDateTimeFormatTz(time: string, targetTz: string): string {
    return moment.tz(time, SERVER_TIMEZONE).tz(targetTz).format('HH:mm dddd, D MMM Y');
  }
  static shortDateFormatTz(time: string, targetTz: string): string {
    return moment.tz(time, SERVER_TIMEZONE).tz(targetTz).format('DD/MM/YY');
  }
  static relativeTimeFormat(time: string, todayLabel: string, yesterdayLabel: string): string {
    const m = moment(time);
    const now = moment();
    const timeStr = m.format('HH:mm');
    if (m.isSame(now, 'day')) return `${todayLabel} ${timeStr}`;
    if (m.isSame(now.clone().subtract(1, 'day'), 'day')) return `${yesterdayLabel} ${timeStr}`;
    return m.format('D MMM HH:mm');
  }
}
